import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import Paper, { PaperProps } from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import classes from './DocumentationPaper.scss'

type DocumentationPaperProps = PaperProps & {
  documentationLink?: string
}

export default function DocumentationPaper({
  title,
  documentationLink,
  children,
  className,
  ...rest
}: DocumentationPaperProps) {
  const { t } = useTranslation(['Publisher'])

  return (
    <Paper elevation={0} className={classNames(classes.root, className)} {...rest}>
      {title ?
        (
          <Typography variant="h3" className={classes.header}>
            {title}
          </Typography>
        ) :
        null
      }

      {children}

      {documentationLink ?
        (
          <div className={classes.documentationLinkContainer}>
            <Button
              variant="contained"
              color="primary"
              href={documentationLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('documentation')}
            </Button>
          </div>
        ) :
        null
      }
    </Paper>
  );
}
